import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import { UserType } from "../types/login.type";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

const signedDeclarationAI = async ({ token }: UserType) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/trade-directory/organization/signed-declaration-of-ai`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default signedDeclarationAI;
